/**
 * Maps prep/notes presence flags to the closed enum of meeting
 * success_variant values understood by the backend allowlist
 * (apps/utils/views.py:ALLOWED_SUCCESS_VARIANTS).
 *
 * Variant meaning:
 * - MEETING_BOTH: meeting was opened with both prep brief and notes
 *   visible — strongest adoption signal.
 * - MEETING_PREP_ONLY: prep brief present, no notes (future meeting).
 * - MEETING_NOTES_ONLY: notes present, no prep (past meeting, no prep ran).
 * - MEETING_NEITHER: neither — slideout opened on a meeting with no
 *   AI-generated content (weakest adoption signal).
 */
export type MeetingSuccessVariant =
  | 'MEETING_PREP_ONLY'
  | 'MEETING_NOTES_ONLY'
  | 'MEETING_BOTH'
  | 'MEETING_NEITHER';

export function deriveMeetingVariant(
  hasPrep: boolean,
  hasNotes: boolean
): MeetingSuccessVariant {
  if (hasPrep && hasNotes) {
    return 'MEETING_BOTH';
  }
  if (hasPrep) {
    return 'MEETING_PREP_ONLY';
  }
  if (hasNotes) {
    return 'MEETING_NOTES_ONLY';
  }
  return 'MEETING_NEITHER';
}
